import { Dropdown, DropdownProps } from "react-bootstrap";
import { ReactComponent as OutlineMenuVertical } from "assets/svg/outline-menu-vertical.svg";

import getClasses from "utils/getClasses";
import styles from "./ActionsDropdown.module.scss";
import { ReactNode } from "react";

type Props = {
  className?: string;
  children: ReactNode;
  menuClassName?: string;
  onSelect?: DropdownProps["onSelect"];
  drop?: DropdownProps["drop"];
  nightMode?: boolean;
};

const ActionsDropdown = ({
  className,
  menuClassName,
  children,
  onSelect,
  drop,
  nightMode = false,
}: Props) => (
  <Dropdown
    className={getClasses(
      styles["dropdown"],
      className,
      nightMode && styles["night-mode"],
    )}
    onSelect={onSelect}
    drop={drop}
    alignRight
  >
    <Dropdown.Toggle variant="link" bsPrefix="p-0">
      <OutlineMenuVertical />
    </Dropdown.Toggle>
    <Dropdown.Menu role={"listbox"} tabIndex={-1} className={menuClassName}>
      {children}
    </Dropdown.Menu>
  </Dropdown>
);

export default ActionsDropdown;
